export default __webpack_public_path__ + "static/media/verdalia.812e5e1f.svg";